// Vendor/admin portals are always dark, the marketplace is always light -
// there is no user-facing toggle. Theme must be derived purely from the
// route, independent of any cross-tab-synced state: a dark portal tab and a
// light marketplace tab are commonly open side by side during demos, and a
// shared/persisted theme key would leak one tab's theme into another.
export function getPortalTheme(pathname: string): "dark" | "light" {
  const isVendorPortal =
    (pathname === "/vendor" || pathname.startsWith("/vendor/")) &&
    !pathname.startsWith("/vendor/application") &&
    !pathname.startsWith("/vendor/register");
  const isDarkPortal = isVendorPortal || pathname.startsWith("/admin");
  return isDarkPortal ? "dark" : "light";
}
